import { render, staticRenderFns } from "./DichVuLuuTruForm.vue?vue&type=template&id=4967616d&scoped=true"
import script from "./DichVuLuuTruForm.vue?vue&type=script&lang=js"
export * from "./DichVuLuuTruForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuLuuTruForm.vue?vue&type=style&index=0&id=4967616d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967616d",
  null
  
)

export default component.exports